import script from "./BigNumbers.vue?vue&type=script&setup=true&lang=ts"
export * from "./BigNumbers.vue?vue&type=script&setup=true&lang=ts"

import "./BigNumbers.vue?vue&type=style&index=0&id=77acd678&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77acd678"]])

export default __exports__